import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import global from '@/utils/common'
import '../src/style/index.scss' // global css

var dayjs = require('dayjs')
import {
  Toast,
  Icon,
  Field,
  Form,
  Button,
  Cell,
  DatetimePicker,
  Popup,
  Picker,
  Dialog,
  List,
  Calendar,
  DropdownMenu,
  DropdownItem,
  Loading 
}  from 'vant';
import 'vant/lib/index.css'
Vue.prototype.dayjs = dayjs
Vue.prototype.$global = global
Vue.config.productionTip = false
Vue.use(Toast).use(Icon).use(Field).use(Form).use(Button).use(Cell).use(DatetimePicker).use(Popup).use(Picker).use(Dialog).use(List).use(Calendar).use(DropdownMenu).use(DropdownItem).use(Loading)

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
